/**
 * @type {ProductStatus}
 * @dec `De-Listing` means end of the life for a product.
 */
export type ProductStatus =
  | 'active'
  | 'inactive'
  | 'de-listing'
  | 'pending'
  | string;
